import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getScopeName, getViewName } from '../../utils/nameFormat';
export const sortColumnsStmtInstruction = `
#### Sort columns
- Syntax: \`sort columns in <view_name>.<scope_name>: <scope_name>, <scope_name>, ... ;\`
- Example: \`sort columns in ${getViewName({ entityName: 'Product', viewType: 'dataGrid' })}.${getScopeName({ entityName: 'Product' })}: name, description, category;\`
`;
export const stmtSortColumns = ({ viewName, scopeName, columnNames }) => {
    return `sort columns in ${viewName}.${scopeName}: ${columnNames.join(', ')};`;
};
export const sortColumnsHandler = createStructureStatementHandler({
    type: 'sort columns',
    parse: line => {
        const match = /^sort columns in (?<viewName>\w+)\.(?<scopeName>\w+): (?<columnNames>[\w\s.,]+)/.exec(line);
        return match?.groups
            ? {
                type: 'sort columns',
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
                columnNames: match.groups.columnNames.split(',').map(it => it.trim()),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.sortColumns({
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
                columnNames: stmt.columnNames,
            });
        });
    },
});
//# sourceMappingURL=SortColumnsStmt.js.map